import * as React from 'react';
import { AppContext, AppContextType } from '../AppContextType';
import { Department } from '../Model/Department';

export interface DepartmentDescriptionProps {
    department: Department
}

export class DepartmentDescription extends React.Component<DepartmentDescriptionProps> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: DepartmentDescriptionProps, context: AppContext) {
        super(props, context);
        this.handleHideClick = this.handleHideClick.bind(this);
    }

    public render() {
        const department = this.props.department;
        const headline = department.descriptionTitle !== '' ? department.descriptionTitle : department.title;
        if (this.context.handler.isDepartmentDescriptionHidden(department)) {
            return null;
        }
        return <div className='jc-department-description col-sm-8 offset-sm-2'>
            <h2>{headline}</h2>
            <p>{department.description}</p>
            <button onClick={this.handleHideClick} className='jc-close-button discreet' aria-hidden={true}>
                <i className="fal fa-times"/>
            </button>
        </div>;
    }

    private handleHideClick() {
        this.context.handler.hideDepartmentDescription(this.props.department);
    }
}
